import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../lib/api";

export default function TrendingBar() {
    const [cfg, setCfg] = useState(null);
    useEffect(() => { api.get("/football/config").then(r => setCfg(r.data)).catch(() => {}); }, []);

    if (!cfg?.trending?.length) return null;
    const items = [...cfg.trending, ...cfg.trending]; // duplicate for seamless scroll

    return (
        <div className="border-y border-white/10 bg-black overflow-hidden" data-testid="trending-bar">
            <div className="max-w-[1400px] mx-auto px-5 md:px-10 flex items-center gap-4 h-10">
                <span className="text-[10px] font-display uppercase tracking-[0.28em] text-[#d4af37] whitespace-nowrap">Digital Beast Trending</span>
                <div className="relative flex-1 overflow-hidden">
                    <div className="flex gap-6 animate-marquee whitespace-nowrap">
                        {items.map((t, i) => (
                            <Link key={`${t}-${i}`} to={`/football/news?q=${encodeURIComponent(t)}`} className="text-white/70 hover:text-[#d4af37] text-xs uppercase tracking-widest transition-colors">
                                <span className="text-[#d4af37] mr-2">·</span>{t}
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
